import React, { FC, Fragment, useEffect, useState } from "react";
import { Col, Collapse, Row, Spin } from "antd";
import { CheckCircleOutlined, CheckCircleFilled } from "@ant-design/icons";
import "./recommendations.scss";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import CustomTooltip from "@pages/tool-tip";
import MemberDetailsService from "@services/memberDetails.service";
import _, { cloneDeep } from "lodash";
import { formatDisplayDate } from "@utils/helpers";
import {useRecommendationDataStore} from "@stores/useRecommendationDataStore";
import moment from "moment";
import ModalCustom from "@components/modal-custom"
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { CanEdit } from '@components/accessLevel'
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../../constants/constants";
const { Panel } = Collapse;

interface RecommendationType {
    patientId: string,
    isActionable: string,
    clinicalRcmdtnDesc: string,
    caremgrActionDate: string,
    rcmdtnInfo: string,
    lastEncounterDate:string,
    rcmdtnDisplayStatus:string,
    dataIndex?:number
}


const Recommendation : FC<any> = (props) => {
  const dataCardId = "4";
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(dataCardId) ? ["1"] : [])
  const [isModalVisible, setIsModalVisible] = useState(false);
  const data = useRecommendationDataStore((state) => state.data);
  const updateData = useRecommendationDataStore((state) => state.updateData);
  const actionableData = useRecommendationDataStore((state) => state.actionableData);
  const setActionableData = useRecommendationDataStore((state) => state.setActionableData);
  const referenceData = useRecommendationDataStore((state) => state.referenceData);
  const setReferenceData = useRecommendationDataStore((state) => state.setReferenceData);
  const [revertRecommendation, setRevertRecommendation] = useState<any>();
  const [revertRecommendationIndex, setRevertRecommendationIndex] = useState<number>(-1);
  const [recommendationType , setRecommendationType] = useState<string>();
  const genExtra = (id: any) => <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler}
  pinCardIds={props.pinCardIds} />;
  const [loading, setLoading] = useState(false);
  const [loadingId, updateLoadingId] = useState(0);

  useEffect(()=> {
    console.log("Recommendation.useEffect1")
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  }, [props?.activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else {props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId])}
  }

  const getHeading = (headerValue: any , tooltipValue?:any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={tooltipValue ? tooltipValue : headerValue}
        children={
          <span
            style={{ margin: "8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );

  const infoIconTooltip = (tooltipvalue: any) => {
    return <CustomTooltip toolTipvalue={tooltipvalue} children={<span className="icon icon-info clr-lightGrayColor"></span>} />;
  };
  
  useEffect(() => {
    console.log("Recommendation.useEffect2");
    //let tempData = cloneDeep(props?.data?.values);
    //updateData(tempData);
    updateData(props?.data?.values);
    setTableData(props?.data?.values);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.data?.values])

  const setTableData = (data : any) => {
    let actionable : RecommendationType[] = [];
    let reference : RecommendationType[] = [];
    data?.forEach((item : RecommendationType , index : number) => {
        if(item.isActionable === "Y"){
            actionable.push({...item , dataIndex : index})
        }else { 
            reference.push({...item , dataIndex : index})
        }
    })
    setActionableData(actionable);
    setReferenceData(reference);
  }

  const handleClick = (recommendation: any, i: number, status: any, oldStatus: any) => {
    if(recommendation?.rcmdtnDisplayStatus?.split("-")[2] !== "g"){
      setLoading(true);
      updateLoadingId(i);
      let tempData: any = cloneDeep(data);
      if(status === "Ongoing"){
          tempData[i].rcmdtnDisplayStatus = "y-c-c";
      }else if(status === "Scheduled"){
          if(tempData[i].rcmdtnDisplayStatus === "y-c-c"){
            tempData[i].rcmdtnDisplayStatus = "p-y-c";
          } else if (tempData[i].rcmdtnDisplayStatus === "c-c-c"){
            tempData[i].rcmdtnDisplayStatus = "c-y-c";
          }
      }
      updateData(tempData);
      setTableData(tempData);
      MemberDetailsService.recommendations(recommendation.patientId, recommendation.clinicalRcmdtnDesc, status).subscribe({
        next: () => {
          setLoading(false);
        },
        error: () => {
          console.log("Some Error Occured.");
          tempData[i].rcmdtnDisplayStatus = oldStatus;
          updateData(tempData);
          setTableData(tempData);
          setLoading(false);
        },
      });
    }
  };

  const handledblClick = (recommendation : any , i: number, status: any) => {
    setIsModalVisible(true);
    setRevertRecommendation(recommendation);
    setRevertRecommendationIndex(i);
    setRecommendationType(status);
  }

  const handleOk = () => {
    setIsModalVisible(false);
    setLoading(true);
    updateLoadingId(revertRecommendationIndex);
    // let tempData: any = cloneDeep(data);
    // let oldStatus = revertRecommendation.rcmdtnDisplayStatus;
    // tempData[revertRecommendationIndex].rcmdtnDisplayStatus = "c-c-c";
    // updateData(tempData);
    // setTableData(tempData);
    MemberDetailsService.revertrecommendations(revertRecommendation.patientId, revertRecommendation.clinicalRcmdtnDesc , recommendationType).subscribe({
      next: () => {
        props.getActionableInsightRecords(revertRecommendation.patientId);
          updateData(props?.data?.values);
          setTableData(props?.data?.values);
          setLoading(false);
      },
      error: () => {
        console.log("Some Error Occured.");
        // tempData[revertRecommendationIndex].rcmdtnDisplayStatus = oldStatus;
        // updateData(tempData);
        // setTableData(tempData);
        setLoading(false);
      },
    });
  }

  return (
    <>
      <Collapse accordion={true} activeKey={activeCardPanel} expandIconPosition="right" bordered={false} onChange={onCollapseChange}>
        <Panel header={getHeading("Recommendations")} key="1" className="recommendations-title" extra={genExtra(dataCardId)}>
          {!_.isEmpty(actionableData) || !_.isEmpty(referenceData) ? (
            <div className="recommendationContainer custom-scroll-bar">
              <Col span={24} className="heading" style={{ paddingBottom: "1rem", display: "flex" }}>
                {getHeading("Actionable", "Actionable Recommendations")}
                <p className="table_heading" style={{ marginTop: "10px" }}>
                  (Please hover on action button to check the last action date)
                </p>
              </Col>
              {!_.isEmpty(actionableData) ? (
                <div>
                  <Row style={{ paddingBottom: "1.5rem" }}>
                    <Col span={8} className="table_heading" style={{ textAlign: "center" }}>
                      Recommendation Name
                    </Col>
                    <Col span={6}></Col>
                    <Col span={4} style={{ display: "flex", justifyContent: "flex-start" }}>
                      <span className="f12 clr-lightGrayColor recommendations-status table_heading">
                        {" "}
                        Latest Gap Closed
                        <span style={{ margin: "0px 8px" }}>{infoIconTooltip("Recent completed date of the recommendation")}</span>
                      </span>
                    </Col>
                    <Col span={2}>
                      <span className="f12 clr-lightGrayColor recommendations-status table_heading fw400"> On Going</span>
                    </Col>
                    <Col span={2}>
                      <span className="f12 clr-lightGrayColor recommendations-status table_heading fw400"> Scheduled</span>
                    </Col>
                    <Col span={2}>
                      <span className="f12 clr-lightGrayColor recommendations-status table_heading fw400"> Completed</span>
                    </Col>
                  </Row>
                  {actionableData?.map((recommendation: any, i: number) => {
                    return (
                      <Fragment key={i}>
                        {loading && loadingId === recommendation.dataIndex ? (
                          <Row style={{ paddingBottom: "1rem" }}>
                            <Col className="recommendation_name_preload shimmerBG"></Col>
                            <Col className="recommendation_info_preload  shimmerBG"></Col>
                            <Col className="recommendation_last_encounter_date_preload shimmerBG"></Col>
                            <Col className="ongoing_preload shimmerBG"></Col>
                            <Col className="scheduled_preload shimmerBG"></Col>
                            <Col className="completed_preload shimmerBG"></Col>
                          </Row>
                        ) : (
                          <Row style={{ paddingBottom: "1rem" }}>
                            <Col span={8} className="recommendation_name">
                              <span className="recommendation_index">{i + 1}.</span>
                              <span style={{ marginTop: "-0.25rem" }}>{recommendation?.clinicalRcmdtnDesc}</span>
                            </Col>
                            <Col span={6} className="recommendation_info">
                              {infoIconTooltip(recommendation?.rcmdtnInfo)}
                            </Col>
                            <Col span={4} className="recommendation_last_encounter_date">
                              {recommendation?.lastEncounterDate ? formatDisplayDate(recommendation?.lastEncounterDate, "reminderDateActualFormat", "") : "NA"}
                            </Col>
                            <Col span={2} style={{ display: "flex", justifyContent: "center" }}>
                              <CanEdit hide={false}>
                                {recommendation?.rcmdtnDisplayStatus?.split("-")[0] === "y" ? (
                                  <CustomTooltip
                                    toolTipvalue={`Last action taken on: ${formatDisplayDate(recommendation?.rcmdtnOngoingActionDate || moment(), "reminderDateActualFormat", "")}`}
                                    children={
                                      <CheckCircleFilled
                                        className="recommendations-status on_going_color cur-pointer"
                                        onDoubleClick={() => handledblClick(recommendation, recommendation.dataIndex, "Ongoing")}
                                      />
                                    }
                                  />
                                ) : recommendation?.rcmdtnDisplayStatus?.split("-")[0] === "p" ? (
                                  <CustomTooltip
                                    toolTipvalue={`Last action taken on: ${formatDisplayDate(recommendation?.rcmdtnOngoingActionDate || moment(), "reminderDateActualFormat", "")}`}
                                    children={<CheckCircleFilled className="recommendations-status check_circle_grey" />}
                                  />
                                ) : (
                                  <CheckCircleOutlined
                                    className={`recommendations-status check_circle_outlined ${recommendation?.rcmdtnDisplayStatus?.split("-")[2] === "g" ? "cur-default" : ""}`}
                                    onClick={() => handleClick(recommendation, recommendation.dataIndex, "Ongoing", recommendation.rcmdtnDisplayStatus)}
                                  />
                                )}
                              </CanEdit>
                            </Col>
                            <Col span={2} style={{ display: "flex", justifyContent: "center" }}>
                              <CanEdit hide={false}>
                                {recommendation?.rcmdtnDisplayStatus?.split("-")[1] === "y" ? (
                                  <CustomTooltip
                                    toolTipvalue={`Last action taken on: ${formatDisplayDate(recommendation?.rcmdtnScheduledActionDate || moment(), "reminderDateActualFormat", "")}`}
                                    children={
                                      <CheckCircleFilled
                                        className="recommendations-status on_going_color cur-pointer"
                                        onDoubleClick={() => handledblClick(recommendation, recommendation.dataIndex, "Scheduled")}
                                      />
                                    }
                                  />
                                ) : recommendation?.rcmdtnDisplayStatus?.split("-")[1] === "p" ? (
                                  <CustomTooltip
                                    toolTipvalue={`Last action taken on: ${formatDisplayDate(recommendation?.rcmdtnScheduledActionDate || moment(), "reminderDateActualFormat", "")}`}
                                    children={<CheckCircleFilled className="recommendations-status check_circle_grey" />}
                                  />
                                ) : (
                                  <CheckCircleOutlined
                                    className={`recommendations-status check_circle_outlined ${recommendation?.rcmdtnDisplayStatus?.split("-")[2] === "g" ? "cur-default" : ""}`}
                                    onClick={() => handleClick(recommendation, recommendation.dataIndex, "Scheduled", recommendation.rcmdtnDisplayStatus)}
                                  />
                                )}
                              </CanEdit>
                            </Col>
                            <Col span={2} style={{ display: "flex", justifyContent: "center" }}>
                              <CanEdit hide={false}>
                                {recommendation?.rcmdtnDisplayStatus?.split("-")[2] === "g" ? (
                                  <CheckCircleFilled className="recommendations-status completed_color" />
                                ) : recommendation?.rcmdtnDisplayStatus?.split("-")[2] === "p" ? (
                                  <CheckCircleFilled className="recommendations-status check_circle_grey" />
                                ) : (
                                  <CheckCircleOutlined className="recommendations-status check_circle_outlined" />
                                )}
                              </CanEdit>
                            </Col>
                          </Row>
                        )}
                      </Fragment>
                    );
                  })}
                </div>
              ) : (
                <DataNotFound message={NO_DATA_FOUND} />
              )}
              <div style={{ borderTop: "1px solid #dfe1e6", paddingBottom: "1rem" }}>
                <Col span={24} className="heading" style={{ paddingTop: "1.5rem", paddingBottom: "3rem" }}>
                  {getHeading("Reference", "Reference Recommendations No Actions Required")}
                </Col>
                <Row>
                  {!_.isEmpty(referenceData) && (
                    <Col span={8} style={{ fontWeight: "500", lineHeight: "12px", fontSize: "12px", textAlign: "center", paddingBottom: "1rem" }}>
                      Recommendation Name
                    </Col>
                  )}
                  {referenceData.length >= 2 && (
                    <Col span={16} style={{ fontWeight: "500", lineHeight: "12px", fontSize: "12px", textAlign: "center", paddingBottom: "1rem" }}>
                      Recommendation Name
                    </Col>
                  )}
                </Row>
                {!_.isEmpty(referenceData) ? (
                  referenceData?.map((recommendation: any, i: number) => {
                    return (
                      <div style={{ display: "flex", flexWrap: "wrap" }} className="w50per">
                        <Spin spinning={loading && loadingId === recommendation.dataIndex} indicator={<HealthemSpinner />}>
                          <Row style={{ paddingBottom: "1rem" }}>
                            <Col span={16} className="recommendation_name">
                              <span className="recommendation_index">{i + 1}.</span>
                              <span style={{ marginTop: "-0.25rem" }}>{recommendation.clinicalRcmdtnDesc}</span>
                            </Col>
                            <Col span={8} style={{ textAlign: "left", display: "flex", alignItems: "baseline", paddingLeft: "1rem", justifyContent: "center" }}>
                              {infoIconTooltip(recommendation.rcmdtnInfo)}
                            </Col>
                          </Row>
                        </Spin>
                      </div>
                    );
                  })
                ) : (
                  <DataNotFound message={NO_DATA_FOUND} />
                )}
              </div>
            </div>
          ) : (
            <DataNotFound message={NO_DATA_FOUND} />
          )}
        </Panel>
      </Collapse>
      <ModalCustom
        title={"Alert"}
        visible={isModalVisible}
        width={500}
        onOk={handleOk}
        setVisible={setIsModalVisible}
        zIndex={2}
        text={"You are trying to revert the Recommendation Action. Do you want to continue ?"}
      />
    </>
  );
};

export default Recommendation;
